<script>
  import BaseFilter from "./base-filter";

  export default {
    extends: BaseFilter,

    computed: {
      /**
       * @return {*}
       */
      pending() {
        return _.get(this.pendingValues, this.name);
      },

      /**
       * @return {Boolean}
       */
      multiple() {
        return Boolean(_.get(this.data, 'multiple', false));
      },

      /**
       * @return {String}
       */
      optionKey() {
        return _.get(this.data, 'optionKey', 'id');
      },

      /**
       * @return {String}
       */
      optionLabel() {
        return _.get(this.data, 'optionLabel', 'title');
      },

      /**
       * @return {String}
       */
      optionValue() {
        return _.get(this.data, 'optionValue', 'id');
      },

      /**
       * @return {String}
       */
      optionDisabled() {
        return _.get(this.data, 'optionDisabled', 'disabled');
      },
    },

    methods: {
      /**
       * @param {*} values
       */
      getFilterLabels(values) {
        return _.isArray(values)
          ? _.map(values, this.getFilterLabel)
          : [this.getFilterLabel(values)];
      },

      /**
       * @param {*} value
       * @param {Number|null} index
       */
      getFilterLabel(value, index = null) {
        return {
          display: this.labelDisplay,
          value: this.getLabelValue(value),
          name: this.name,
          index: index,
        };
      },

      /**
       * @param {Number|null} value
       * @return {String}
       */
      getLabelValue(value) {
        const option = _.find(this.options, {[this.optionValue]: value});

        return _.get(option, this.optionLabel, value);
      },
    },
  }
</script>
